import { packingTemplateIdFormat } from "@redotech/redo-fulfillment-id";
import { PackingTemplateType } from "@redotech/redo-inventory-common/packing-template";
import { productIdFormat } from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const PackingTemplateOptionSchema = z.object({
  id: packingTemplateIdFormat.schema,
  name: z.string(),
  templateType: createEnum(PackingTemplateType),
  unitsPerBox: z.number().int().positive().nullable(),
  isProductDefault: z.boolean(),
});

export type PackingTemplateOption = z.infer<typeof PackingTemplateOptionSchema>;

export const getPackingTemplatesForProducts = {
  name: "getPackingTemplatesForProducts" as const,
  input: z.object({ productIds: z.array(productIdFormat.schema) }),
  output: z.object({
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        templates: z.array(PackingTemplateOptionSchema),
      }),
    ),
  }),
};
